import { useState, useCallback } from 'react';

/**
 * State machine for canvas tools.
 * Tools: 'select', 'pan', 'edit'
 * Special modes: 'addwall', 'addroom', 'addtext' (overlay on top of edit)
 */
export default function useCanvasTools() {
  const [tool, setToolState] = useState('pan');
  const [specialMode, setSpecialMode] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const setTool = useCallback((t) => {
    setSpecialMode(null);
    setToolState(t);
    setEditMode(t === 'edit');
  }, []);

  const enterSpecialMode = useCallback((mode) => {
    setSpecialMode(mode);
    if (mode === 'addwall') {
      setToolState('edit');
      setEditMode(true);
    }
  }, []);

  const cancelSpecialMode = useCallback(() => {
    setSpecialMode(null);
  }, []);

  const getCursor = useCallback(() => {
    if (specialMode) return 'crosshair';
    switch (tool) {
      case 'pan': return 'grab';
      case 'edit': return 'crosshair';
      default: return 'default';
    }
  }, [tool, specialMode]);

  return {
    tool,
    setTool,
    editMode,
    specialMode,
    enterSpecialMode,
    cancelSpecialMode,
    getCursor,
    isPan: tool === 'pan',
    isEdit: tool === 'edit' || editMode,
    isSelect: tool === 'select',
  };
}
